import { Layout } from "@mcleod/components";

export abstract class AutogenLayoutEdiProfilesLookup extends Layout {
}
